import WebLayout from './TextWithLinksFieldLayout.web';
import MobileLayout from './TextWithLinkFieldLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
